// Shared with the authoritative backend; no browser APIs in these rules.
import rules from './shared/config';
export const { GAME_CONFIG, CAMERA_STREAK_TIERS, GAME_STAGES, getStageById, getStageForElapsedTime, getCameraTierForStreak, calculateTimeMultiplier, getPenaltyForTime, getHitsUntilLose, getDangerDistanceRatio } = rules;
